import ProductListProductCard, { ProductCardProps } from "@affinity/components/ProductList/ProductListCard";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import React from "react";
import styled from "styled-components";

type Props = {
    productCards: ProductCardProps[];
    rdcoPopups: RdcoPopups;
    onChange: (product: ProductCardProps) => void;
    onConfirm?: (product: ProductCardProps) => void;
};

// export interface RdcoPopups { [category: string]: RdcoPopup }
export type RdcoPopups = Map<string, RdcoPopup>;

export interface RdcoPopup {
    title: string;
    content: string;
}

export const CardGridContainer = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${styleHelpers.rem(20)};
    @media (min-width: ${styleHelpers.rem(768)}) {
        gap: ${styleHelpers.rem(30)};
        grid-template-columns: minmax(1px, 1fr) minmax(1px, 1fr);
    }
    @media (min-width: ${styleHelpers.rem(1280)}) {
        gap: ${styleHelpers.rem(40)};
    }
`;

const ProductListCardGrid = ({ productCards, rdcoPopups }: Props) => {
    return (
        <CardGridContainer>
            {productCards.map((product: ProductCardProps) => (
                <ProductListProductCard key={product.id} {...product} />
            ))}
        </CardGridContainer>
    );
};

export default ProductListCardGrid;
